<template><div>
  <div class="error" v-html="submitError" v-if="submitError" />
  <table>
    <tr v-for="(f,i) in ff" :key="f[1]">
      <th v-html="f[0]" />
      <td ref="tabstop">
        <input v-model="pr[f[1]]" :name="f[1]" @keydown.enter="pressEnter(i)" v-if="f[1] !== 'part'" />
        <select v-model="pr[f[1]]" :name="f[1]" @keydown.enter="pressEnter(i)" v-else>
          <option v-for="p in parts.list" :key="`p-${p[0]}`" :value="p[0]" v-html="p[1]" />
        </select>
      </td>
    </tr>
  </table>
  <Loading v-if="submitRef !== null" />
  <button ref="submit" @click="submit" v-else-if="pr.serial_no || pr.imei || pr.part || pr.mac || pr.sim || pr.firmware_version || pr.config_version">Submit</button>
  <button disabled v-else>Submit</button>
</div></template>
<script>
import Loading from './Loading'
export default {
  name: 'provisioning-form',
  components: { Loading },
  props: ['pr','parts'],
  emits: ['done'],
  data() {
    return {
      ff: [
        ['Serial','serial_no'],
        ['IMEI','imei'],
        ['Part','part'],
        ['MAC/LAN','mac'],
        ['Sim ICCID','sim'],
        ['FW Version','firmware_version'],
        ['Config Version','config_version'],
      ],
      submitRef: null,
      submitError: null,
    }
  },
  mounted() {
    this.$refs.tabstop[0].focus()
  },
  methods: {
    pressEnter(i) {
      i++
      if (i < this.ff.length) this.$refs.tabstop[i].children[0].focus()
      else this.$refs.submit.focus()
    },
    async submit() {
      if (this.submitRef)
        this.submitRef.cancel()
      let ref = {}
      if ('id' in this.pr) ref.id = this.pr.id
      for (const [ txt, key ] of this.ff) {
        ref[key] = this.pr[key]
      }
      ref = { data: ref }
      this.submitRef = ref
      this.submitError = null
      try {
        await api.addProvisioningRecord(ref)
        this.$emit('done')
      } catch(e) {
        console.error(e)
        if (e instanceof api.RemoteError)
          this.submitError = 'A remote error occurred: ' + e.message
        else
          this.submitError = 'An error occurred!'
      } finally {
        if (this.submitRef == ref)
          this.submitRef = null
      }
    },
  },
}
</script>
<style lang="scss" scoped>
table { margin-bottom: 1em; }
button { font-size: 150%; border: 2px solid transparent; &:focus { background-color: #ddd; border: 2px solid #f80; } }
select { border: 1px solid #666; border-radius: 0; padding: inherit; width: 100%; }
.error { margin-bottom: 10px; }
</style>
